import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

import { NamedLink } from '../../../../components';
import { FormattedMessage } from '../../../../util/reactIntl';

import css from './SectionInterestingNearby.css';
import { getCurrentUserLocation } from '../../../../util/localStorage';
import { getCountryConfig } from './getCountryConfig';

const defaultCountry = 'CH';

const countryCodeMapper = {
    DE: 'DE',
    CH: 'CH',
    AT: 'DE',
};

export default ({ type, headingId, descriptionId, subHeadingId }) => {
    const [tabSelected, setTabSelected] = useState(defaultCountry);
    const { country, countrySelected } = getCurrentUserLocation();
    const userCountry = countrySelected || country;

    const { primary, secondary } = getCountryConfig(type, tabSelected) || {
        primary: [],
        secondary: [],
    };

    useEffect(() => {
        setTabSelected(countryCodeMapper[userCountry] || defaultCountry);
    }, [userCountry]);

    return (
        <section className={css.root}>
            <header className={css.content}>
                <h2 className={css.subHeading}>
                    <FormattedMessage id={subHeadingId} />
                </h2>
                <p className={css.heading}>
                    <FormattedMessage id={headingId} />
                </p>
                <p>
                    <FormattedMessage id={descriptionId} />
                </p>
            </header>

            <main className={css.nearbyHolder}>
                <nav className={css.tabs}>
                    <h3
                        onClick={() => setTabSelected('CH')}
                        className={classNames({
                            [css.tabSelected]: tabSelected === 'CH',
                        })}
                    >
                        Schweiz
                    </h3>
                    <h3
                        onClick={() => setTabSelected('DE')}
                        className={classNames({
                            [css.tabSelected]: tabSelected === 'DE',
                        })}
                    >
                        Deutschland
                    </h3>
                </nav>

                <header>
                    <h4 className={css.countryHeader}>
                        <FormattedMessage
                            id={`SectionInterestingNearby.tab-heading-${tabSelected}`}
                        />
                    </h4>

                    <div className={css.primaryLocations}>
                        {primary.map(({ label, link: search, backgroundUrl }) => (
                            <NamedLink key={label} name="SearchPage" to={{ search }}>
                                <div
                                    className={css.primaryLink}
                                    style={{
                                        backgroundImage: `url('${backgroundUrl}')`,
                                    }}
                                >
                                    <span>{label}</span>
                                </div>
                            </NamedLink>
                        ))}
                    </div>

                    <h4 className={css.countryHeader}>
                        <FormattedMessage
                            id={`SectionInterestingNearby.links-heading-${tabSelected}`}
                        />
                    </h4>

                    <div
                        className={classNames(css.secondaryLocations, {
                            [css.threeColumn]: tabSelected === 'DE',
                            [css.fourColumn]: tabSelected === 'CH',
                        })}
                    >
                        {secondary.map(({ label, link: search }) => (
                            <NamedLink key={label} name="SearchPage" to={{ search }}>
                                <p>{label}</p>
                            </NamedLink>
                        ))}
                    </div>
                </header>
            </main>

            <footer className={css.footer}></footer>
        </section>
    );
};
